import classNames from './Done.module.scss';
import mineClassNames from '../DeleteTeacherModal.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import TheButton from '@/components/school-management/TheButton/TheButton';
import { useMemo } from 'react';
import { DeletedTeacherGroupData } from '@/school-management/types/response/teacher';

export interface DoneDescriptionData {
  deletedStudents: number;
  deletedClasses: number;
  reassigned: {
    [toTeacherId: string]: {
      teacherName: string;
      numberOfStudents: number;
      numberOfClasses: number;
    };
  };
}

interface DoneProps {
  teacherName: string;
  descriptionData: DoneDescriptionData;
  //FIXME: this is a temporal solution till the backend will fix the response
  emptyGroupsPotentiallyDeleted: DeletedTeacherGroupData[];
  onConfirm: () => void;
}

const Done = ({
  teacherName,
  descriptionData,
  emptyGroupsPotentiallyDeleted,
  onConfirm,
}: DoneProps) => {
  const { t } = useAdminTranslation();

  const description = useMemo(() => {
    let deletedDescription = '';
    let reassignedDescription = '';
    const deletedTeacherDescription = t(
      'schoolDetailsPage.classes.deleteTeacherModal.done.teacherHasBeenRemoved',
      {
        teacherName: teacherName,
      }
    );
    //FIXME: this is a temporal solution till the backend will fix the response
    const isDeleted =
      descriptionData.deletedClasses > 0 || emptyGroupsPotentiallyDeleted.length > 0;
    const reassignedTeachers = Object.keys(descriptionData.reassigned);
    const isReassigned = reassignedTeachers.length > 0;

    if (isDeleted) {
      deletedDescription = t(
        descriptionData.deletedStudents > 0
          ? 'schoolDetailsPage.classes.deleteTeacherModal.done.deletedNStudentsXClasses'
          : 'schoolDetailsPage.classes.deleteTeacherModal.done.deleted0StudentsXClasses',
        {
          deletedStudents: descriptionData.deletedStudents,
          //FIXME: this is a temporal solution till the backend will fix the response
          deletedClasses: descriptionData.deletedClasses + emptyGroupsPotentiallyDeleted.length,
        }
      );
    }

    if (isReassigned) {
      reassignedDescription = t(
        reassignedTeachers.length > 1
          ? 'schoolDetailsPage.classes.deleteTeacherModal.done.reassignedToNTeachers'
          : 'schoolDetailsPage.classes.deleteTeacherModal.done.reassignedTo1Teacher',
        {
          numberOfClasses: reassignedTeachers.reduce((acc, teacherId) => {
            acc += descriptionData.reassigned[teacherId]?.numberOfClasses || 0;
            return acc;
          }, 0),
          numberOfStudents: reassignedTeachers.reduce((acc, teacherId) => {
            acc += descriptionData.reassigned[teacherId]?.numberOfStudents || 0;
            return acc;
          }, 0),
          teacherName: descriptionData.reassigned[reassignedTeachers[0]].teacherName,
        }
      );
    }

    return {
      deletedDescription,
      reassignedDescription,
      deletedTeacherDescription,
    };
  }, [t, teacherName, descriptionData]);

  return (
    <div className={classNames.content}>
      <h2>{t('schoolDetailsPage.classes.deleteTeacherModal.done.title')}</h2>
      <div className={classNames.description}>
        {description.reassignedDescription && <div>{description.reassignedDescription}</div>}
        {description.deletedDescription && <div>{description.deletedDescription}</div>}
        {description.deletedTeacherDescription && (
          <div>{description.deletedTeacherDescription}</div>
        )}
      </div>
      <div className={mineClassNames.buttonsContainer}>
        <TheButton
          className={mineClassNames.confirmBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.done.btn')}
          shouldRecolor={false}
          emitOnClick={onConfirm}
        />
      </div>
    </div>
  );
};

export default Done;
